.device-location-control {
  position: absolute;
  right: 10px;
  bottom: 40px;
  z-index: 1000;
  display: flex;
  flex-direction: column-reverse;
  align-items: flex-end;
  max-width: min(320px, calc(100% - 20px));

  .device-location-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    padding: 10px;
    border: 0;
    border-radius: 4px;
    background: #fff;
    color: #333;
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.4);

    &:hover {
      background: #f4f4f4;
    }

    &:focus-visible {
      outline: 3px solid #007e66;
      outline-offset: 2px;
    }

    &:disabled {
      cursor: wait;
      opacity: 0.65;
    }

    svg {
      width: 24px;
      height: 24px;
    }
  }

  [role='status'] {
    transition:
      opacity 300ms,
      visibility 300ms;

    &.device-location-feedback-dismissed {
      opacity: 0;
      visibility: hidden;
    }

    @media (prefers-reduced-motion: reduce) {
      transition: none;
    }
  }

  [role='status']:not(:empty) {
    margin-bottom: 8px;
    padding: 8px 12px;
    border-radius: 4px;
    background: #fff;
    color: #333;
    font-size: 14px;
    line-height: 1.4;
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.25);
  }
}
